export default "__VITE_ASSET__DmiVWQyR__"